export const REPORT_COLUMNS_LIBRARY_REQUEST = 'REPORT_COLUMNS_LIBRARY_REQUEST'
export const REPORT_COLUMNS_LIBRARY_SUCCESS = 'REPORT_COLUMNS_LIBRARY_SUCCESS'
export const REPORT_COLUMNS_LIBRARY_FALIURE = 'REPORT_COLUMNS_LIBRARY_FALIURE'
export const REPORT_COLUMNS_REQUEST = 'REPORT_COLUMNS_REQUEST'
export const REPORT_COLUMNS_SUCCESS = 'REPORT_COLUMNS_SUCCESS'
export const REPORT_COLUMNS_FALIURE = 'REPORT_COLUMNS_FALIURE'
export const UPDATE_REPORT_COLUMNS_REQUEST = 'UPDATE_REPORT_COLUMNS_REQUEST'
export const UPDATE_REPORT_COLUMNS_SUCCESS = 'UPDATE_REPORT_COLUMNS_SUCCESS'
export const UPDATE_REPORT_COLUMNS_FALIURE = 'UPDATE_REPORT_COLUMNS_FALIURE'